import { useState } from 'react';
import { ReactComponent as Star } from "../../assets/icons-redesign/ai-star.svg";
import AiSampleSize from './ai-sample-size';
import { Dialog } from 'primereact/dialog';
import { isQA } from 'src/helpers/env.helpers';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../ui/dropdown-menu';
import { Button } from '../ui/button';
import { ChevronDown } from 'lucide-react';
import { useGetPanelsQuery } from 'src/pages/surveys/endpoints/panel.endpoints';
import { Panel } from 'src/pages/surveys/types/panel.types';

interface CriteriaCardProps {
  extSurveyId: string;
}

const SurveyResponderTrigger = ({ extSurveyId }: CriteriaCardProps) => {
  const { data: panels } = useGetPanelsQuery();
  const [selectedPanel, setSelectedPanel] = useState<Panel | null>(null);

  let ai: number[] = [];
  if (isQA()) {
    ai = [0, 10, 50, 100, 200];
  } else {
    ai = [0, 100, 200, 500, 750, 1000];
  }


  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const iconStroke = 'white';
  return (
    <div>
      <button
        className="bg-purple-500 text-white px-3 py-2 h-[40px] rounded-full relative z-50"
        onClick={() => setIsOpen(true)}
      >
        <div className='cursor-pointer flex items-center gap-1.5 text-sm md:text-base font-medium'>
          <Star stroke={iconStroke} />
          {/* AI Panelists */}
        </div>
      </button>

      <Dialog
        visible={isOpen}
        onHide={() => setIsOpen(false)}
      >
        <div className="p-0 max-w-xs w-[330px]">

          <div className="px-4 pb-4">
            <h2 className="text-lg font-medium">
              AI Panelists
            </h2>
            <div className="mt-2">
              <DropdownMenu
                open={dropdownOpen}
                onOpenChange={setDropdownOpen}
                modal={false}
              >
                <DropdownMenuTrigger asChild>
                  <Button
                    variant="outline"
                    className="w-full justify-between p-4 rounded-lg m-0"
                    size="med"
                  >
                    {selectedPanel ? selectedPanel.name : 'Select Panel'}
                    <ChevronDown className="w-4 h-4" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="z-[9999]">
                  {panels?.filter((panel) => panel.panel_type === 'ai' && panel.status === 'active' && panel.locked === true).map((panel) => (
                    <DropdownMenuItem
                      key={panel.id}
                      onClick={() => setSelectedPanel(panel)}
                    >
                      <div className="flex flex-col gap-2 border-b border-gray-200 pb-2">
                        <span className="font-medium ">
                          {panel.name}
                        </span>
                        <div className="flex justify-between gap-2">
                          <span className="text-xs text-gray-500 mt-0">
                            {panel.panelists}
                            {' '}
                            panelists
                          </span>
                          <span className="text-xs text-gray-500 mt-0">
                            {panel.fields.filter((field) => field.status === 'active').length}
                            {' '}
                            fields
                          </span>
                        </div>
                      </div>
                    </DropdownMenuItem>
                  ))}
                </DropdownMenuContent>
              </DropdownMenu>
            </div>
          </div>
          <div className="px-4 pb-4">
            {selectedPanel && (
              <AiSampleSize
                extSurveyId={extSurveyId}
                sampleSizes={ai}
                panelId={selectedPanel?.id || ''}
                zeroDisabled={false}
                onSubmit={() => setIsOpen(false)}
              />
            )}
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default SurveyResponderTrigger;
